import classnames from 'classnames';

export function Card (props) {
  return (
    <div className={
      classnames(
        'border-1', 
        'has-background', 
        'has-white-background-color',
        'p-6',
        'rounded-md',
        'shadow-md', 
        'wp-block-group',
        'mb-6',
        props.className
      )}>
      {props.children}
    </div>
  )
}